// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"825fc4dc-168":"1446da02b0d1545213db","825fc4dc-452":"78f27682f97590fc3764","825fc4dc-379":"767fc139608c572593fa","825fc4dc-83":"08a175003b78a356420f"}[chunkId] + ".js";
};